import { createReducer } from "reduxsauce";

const ActionTypes = {
    THEME_TOGGLE_THEME: "THEME_TOGGLE_THEME"
};

const Actions = {
    toggleTheme: () => ({ type: ActionTypes.THEME_TOGGLE_THEME }),
};

/* ------------- Initial State ------------- */

const INITIAL_STATE = {
    mytheme: "light",
};

/* ------------- Reducers ------------- */
const toggleThemeReducer = (state) => {
    state.mytheme = state.mytheme === "light" ? "dark" : "light";
    return state;
};

/* ------------- Hookup Reducers To Types ------------- */

const reducer = createReducer(INITIAL_STATE, {
    [ActionTypes.THEME_TOGGLE_THEME]: toggleThemeReducer,
});

export { Actions, ActionTypes, reducer, INITIAL_STATE };
